import get from 'lodash/fp/get';

export const getMessageList = get('messageList');
